import { Flex, FlexProps } from "@mantine/core";
import { CSSProperties } from "react";

import {
  MuiResponsiveValue,
  useMuiResponsiveValue,
} from "~/hooks/useMuiResponsiveValue";

// Centered flex container. `direction`/`spacing` and the grid-item props keep
// the MUI Stack call-site API during the MUI → Mantine migration (spacing is
// the MUI 8px unit); they are renamed page by page.
export type CenterProps = Omit<FlexProps, "gap"> & {
  spacing?: number;
  gap?: FlexProps["gap"];
  gridColumn?: MuiResponsiveValue<CSSProperties["gridColumn"]>;
  gridRow?: CSSProperties["gridRow"];
  gridTemplateColumns?: CSSProperties["gridTemplateColumns"];
};

const Center = ({
  spacing,
  gap,
  direction = "column",
  gridColumn,
  gridRow,
  gridTemplateColumns,
  style,
  ...rest
}: CenterProps) => {
  const resolvedGridColumn = useMuiResponsiveValue(gridColumn);

  return (
    <Flex
      justify="center"
      align="center"
      direction={direction}
      gap={gap ?? (spacing !== undefined ? spacing * 8 : undefined)}
      style={{
        gridColumn: resolvedGridColumn,
        gridRow,
        gridTemplateColumns,
        ...style,
      }}
      {...rest}
    />
  );
};

export default Center;
